import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postGeneralIncomeType } from '../../../../actions';
import { GENERAL_INCOME_TYPE_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import GeneralIncomeTypeForm from './GeneralIncomeTypeForm';

const NewGeneralIncomeType = ({ breadcrumbs, dispatchpostGeneralIncomeType }) => {
  const onSubmit = (formValues) =>
    dispatchpostGeneralIncomeType({
      ...formValues,
      generalIncomeTypeLabel: formValues.generalIncomeTypeLabelId.value
    });

  const content = <GeneralIncomeTypeForm onSubmit={onSubmit} />;
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Tipo de Ingreso"
      subtitle="Crear un nuevo tipo de ingreso."
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchpostGeneralIncomeType: postGeneralIncomeType,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Ingreso',
      href: GENERAL_INCOME_TYPE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

NewGeneralIncomeType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchpostGeneralIncomeType: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewGeneralIncomeType);
